module.exports = __webpack_public_path__ + "img/RecoveryEmail.f514afc7.webp";